import {
  BadgeXIcon,
  BadgeCheckIcon,
  Home,
  Gauge,
  BookOpen,
  Laptop,
  Store,
  Globe,
  Users,
  Server,
  CloudCog,
  Terminal,
  Settings,
  Plug,
  BadgeAlert,
  AlertTriangle,
  KeyRound,
  Briefcase,
  Wrench,
  Copy,
  RefreshCcw,
  RefreshCw,
  Rocket,
  PackageCheckIcon,
  PackagePlus,
  Save,
  MessagesSquare,
  Trash2,
  Workflow,
  FileText,
  Puzzle,
  ShieldCheck,
  ShieldX,
  Loader2,
  CircleCheck,
  ClipboardList,
  ExternalLink,
  Eye,
  UserPlus,
  Plus,
  X,
  CircleCheckIcon,
  Upload,
  Check,
  CircleX,
  Ban,
  ListFilter,
  MailIcon,
  FlagIcon,
  InfoIcon,
  MousePointerIcon,
  CheckCircleIcon,
  XCircleIcon,
  ArrowRight,
  ArrowLeft,
  ArrowUpRight,
  ArrowUpDown,
  ArrowUp,
  ArrowDown,
  Download,
  User,
  GitBranch,
  Box,
  Container,
  FileIcon,
  Clock,
  Building2,
  ShieldAlert,
  Hash,
  CircleHelp,
  Database,
  Radio,
  Wifi,
  WifiOff,
  EllipsisVertical,
  FileDownIcon,
  FileQuestionIcon,
  CalendarArrowUp,
  CalendarIcon,
  Cloud,
  ChevronRight,
  Monitor,
  Cpu,
  Layers,
  MemoryStick,
  MoveRight,
  HistoryIcon,
  Lock,
  LockOpen,
  AlertCircle,
  ClipboardPlus,
  ChevronDown,
  ChevronsUpDown,
  ChevronLeft,
  ChevronsLeft,
  ChevronsRight,
  Pencil,
  LogOut,
  Paperclip,
  Link2,
  Unlink2,
  Square,
  Search,
  Bell,
  BellOff,
  PenLine,
  Smartphone,
  Sparkles,
  Library,
  FilePlus,
  Activity,
  EyeOff,
  Fingerprint,
  UsersRound,
  GraduationCap,
  TabletSmartphone,
  MapPin,
  Timer,
  UserRoundCheck,
  Scale,
  CheckCheck,
  Bug,
  AtSign,
  MessageSquare,
  FileCheck,
  FileSignature,
  Play,
  UserCog,
  Archive,
  Zap,
  Network,
  Boxes,
} from 'lucide-react'

export const ICONS = {
  'badge-close': BadgeXIcon,
  'download': Download,
  'badge-check': BadgeCheckIcon,
  'home-outlined': Home,
  'speed-outlined': Gauge,
  'book-outlined': BookOpen,
  'devices-outlined': Laptop,
  'storefront-outlined': Store,
  'package-check': PackageCheckIcon,
  'public-outlined': Globe,
  'groups-outlined': Users,
  'dns-outlined': Server,
  'cloud-done-outlined': CloudCog,
  'terminal-outlined': Terminal,
  'settings-outlined': Settings,
  'power-outlined': Plug,
  'badge-outlined': BadgeAlert,
  'crisis-alert': AlertTriangle,
  'key-outlined': KeyRound,
  'briefcase-outlined': Briefcase,
  'wrench-outlined': Wrench,
  'copy': Copy,
  'globe': Globe,
  'user': User,
  'package': Box,
  'refresh-outlined': RefreshCcw,
  'refresh': RefreshCw,
  'rocket': Rocket,
  'package-plus': PackagePlus,
  'plus': Plus,
  'save': Save,
  'comments': MessagesSquare,
  'trash': Trash2,
  'workflow': Workflow,
  'user-plus': UserPlus,
  'file-text': FileText,
  'puzzle': Puzzle,
  'shield-check': ShieldCheck,
  'loader': Loader2,
  'circle-check': CircleCheck,
  'clipboard-list': ClipboardList,
  'clipboard-plus': ClipboardPlus,
  'external-link': ExternalLink,
  'eye': Eye,
  'x': X,
  'circle-check-icon': CircleCheckIcon,
  'circle-x': CircleX,
  'ban': Ban,
  'upload': Upload,
  'check': Check,
  'list-filter': ListFilter,
  'mail': MailIcon,
  'file': FileIcon,
  'flag': FlagIcon,
  'mouse-pointer': MousePointerIcon,
  'check-circle-icon': CheckCircleIcon,
  'x-circle': XCircleIcon,
  'arrow-right': ArrowRight,
  'arrow-left': ArrowLeft,
  'arrow-up-right': ArrowUpRight,
  'info': InfoIcon,
  'git-branch': GitBranch,
  'container': Container,
  'clock': Clock,
  'building': Building2,
  'shield-alert': ShieldAlert,
  'hash': Hash,
  'circle-help': CircleHelp,
  'database': Database,
  'arrow-up-down': ArrowUpDown,
  'arrow-up': ArrowUp,
  'arrow-down': ArrowDown,
  'radio': Radio,
  'wifi': Wifi,
  'wifi-off': WifiOff,
  'ellipsis-vertical': EllipsisVertical,
  'file-down': FileDownIcon,
  'file-question': FileQuestionIcon,
  'calendar-arrow-up': CalendarArrowUp,
  'calendar': CalendarIcon,
  'shield-x': ShieldX,
  'cloud': Cloud,
  'chevron-right': ChevronRight,
  'monitor': Monitor,
  'smartphone': Smartphone,
  'cpu': Cpu,
  'layers': Layers,
  'memory-stick': MemoryStick,
  'move-right': MoveRight,
  'history': HistoryIcon,
  'lock': Lock,
  'lock-open': LockOpen,
  'alert-circle': AlertCircle,
  'chevron-down': ChevronDown,
  'chevrons-up-down': ChevronsUpDown,
  'chevron-left': ChevronLeft,
  'chevrons-left': ChevronsLeft,
  'chevrons-right': ChevronsRight,
  'pencil': Pencil,
  'penline': PenLine,
  'log-out': LogOut,
  'paperclip': Paperclip,
  'link': Link2,
  'unlink': Unlink2,
  'square': Square,
  'search': Search,
  'bell': Bell,
  'bell-off': BellOff,
  'sparkles': Sparkles,
  'library': Library,
  'file-plus': FilePlus,
  'activity': Activity,
  'eye-off': EyeOff,
  'fingerprint': Fingerprint,
  'users-round': UsersRound,
  'graduation-cap': GraduationCap,
  'tablet-smartphone': TabletSmartphone,
  'map-pin': MapPin,
  'timer': Timer,
  'user-round-check': UserRoundCheck,
  'scale': Scale,
  'check-check': CheckCheck,
  'bug': Bug,
  'at-sign': AtSign,
  'message-square': MessageSquare,
  'file-check': FileCheck,
  'file-signature': FileSignature,
  'play': Play,
  'user-cog': UserCog,
  'archive': Archive,
  'zap': Zap,
  'network': Network,
  'boxes': Boxes,
} as const

export type IAvailableIcons = keyof typeof ICONS

interface IIconProps {
  icon: keyof typeof ICONS
  className?: string
  fill?: string
}

export default function Icon({ icon, className, fill = 'none' }: IIconProps) {
  const IconComponent = ICONS[icon]
  return <IconComponent className={className} fill={fill} />
}
